module.exports = "<div class=\"modal__holder map-modal\" id=\"map-modal\">\r\n    <div class=\"modal-inner\">\r\n        <div class=\"bg js-close-modal\">&nbsp;</div>\r\n        <div class=\"modal__container modal__container--bgn\">\r\n          <a href=\"#\" class=\"modal__close-ico \" ng-click=\"$ctrl.visible=false\">+</a>\r\n          <div class=\"modal__body\">\r\n           \r\n            <div class=\"modal-paint-map\" id=\"js-map-paint\"></div>\r\n          </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/html/modal-map.html
// module id = 167
// module chunks = 1